import track from '../../assets/new-ui/mint/mint-incentive-track.png'
import trackMobile from '../../assets/new-ui/mint/mint-incentive-track-mobile.png'
export default function IncentiveTrack() {
  
  return (
    <div className='incentiveTrackContainer'>
      <img src={track} alt='track' className='track'/>
      <img src={trackMobile} alt='track' className='trackMobile' />
      <div className='trackElement track1'>
        <div className='trackDetail'>
          <div>5 NFTs</div>
          <div>1%</div>
          <div>Gain 1% revenue from selling NFT when this period finish</div>
        </div>
        <div className='trackDetailMobile'>
          <div>5 NFTs - 1%</div>
          <div>Gain 1% revenue from selling NFT when this period finish</div>
        </div>
        
      </div>

      <div className='trackElement track2'>
        <div className='trackDetail'>
          <div>10 NFTs</div>
          <div>2%</div>
          <div>Gain 2% revenue from selling NFT when this period finish</div>
        </div>
        <div className='trackDetailMobile'>
          <div>10 NFTs - 2%</div>
          <div>Gain 2% revenue from selling NFT when this period finish</div>
        </div>
      </div>

      <div className='trackElement track3'>
        <div className='trackDetail'>
          <div>15 NFTs</div>
          <div>3%</div>
          <div>Gain 3% revenue from selling NFT when this period finish</div>
        </div>
        <div className='trackDetailMobile'>
          <div>15 NFTs - 3%</div>
          <div>Gain 3% revenue from selling NFT when this period finish</div>
        </div>
      </div>

      <div className='trackElement track4'>
        <div className='trackDetail'>
          <div>20 NFTs</div>
          <div>4%</div>
          <div>Gain 4% revenue from selling NFT when this period finish</div>
        </div>
        <div className='trackDetailMobile'>
          <div>20 NFTs - 4%</div>
          <div>Gain 4% revenue from selling NFT when this period finish</div>
        </div>
      </div>

      <div className='trackElement track5'>
        <div className='trackDetail'>
          <div>30 NFTs</div>
          <div>5%</div>
          <div>Gain 5% revenue from selling NFT when this period finish</div>
        </div>
        <div className='trackDetailMobile'>
          <div>30 NFTs - 5%</div>
          <div>Gain 5% revenue from selling NFT when this period finish</div>
        </div>
      </div>
    </div>
  )
}